<template>
       <div class="min-h-screen bg-gray-50 p-4">
    <div >
 
      <!-- 网址信息模块 -->
      <div class="bg-white rounded-xl shadow-sm p-4 mb-2 flex items-center">
        <div class="w-32 text-gray-700 font-medium">官方网站</div>
        <div class="flex-1">
          <a :href="getDictVal('website')" target="_blank" class="text-blue-600 hover:underline">{{ getDictVal('website') }}</a>
          <p class="text-gray-500 text-sm mt-1">公司官方网站，提供产品介绍与最新资讯</p>
        </div>
      </div>



      <!-- 系统信息模块 -->
      <div class="bg-white rounded-xl shadow-sm p-6 mb-6">
        <div class="w-32 text-gray-700 font-medium mb-4">系统信息</div>
        <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
          <div>
            <div class="text-gray-600 text-sm">PHP版本</div>
            <div class="font-medium">{{ getDictVal('php') }}</div>
          </div>
          <div>
            <div class="text-gray-600 text-sm">Nginx版本</div>
            <div class="font-medium">{{ getDictVal('nginx') }}</div>
          </div>
          <div>
            <div class="text-gray-600 text-sm">数据库</div>
            <div class="font-medium">{{ getDictVal('mysql') }}</div>
          </div>
  
        </div>
      </div>

      <!-- 宝塔面板信息 -->
      <div class="bg-white rounded-xl shadow-sm p-6 mb-6">
        <div class="w-32 text-gray-700 font-medium mb-4">宝塔面板</div>
        <div class="space-y-4">
          <div class="flex items-center">
            <span class="text-gray-600 w-24">外网地址:</span>
            <a :href="getDictVal('bt_external_url')" target="_blank" class="text-blue-600 hover:underline flex-1">{{ getDictVal('bt_external_url') }}</a>
            <div link class="ml-2" @click="copyText(getDictVal('bt_external_url'))">
              复制
            </div>
          </div>
          <div class="flex items-center">
            <span class="text-gray-600 w-24">内网地址:</span>
            <a :href="getDictVal('bt_internal_url')" target="_blank" class="text-blue-600 hover:underline flex-1">{{ getDictVal('bt_internal_url') }}</a>
            <div link class="ml-2" @click="copyText(getDictVal('bt_internal_url'))">
              复制
            </div>
          </div>
          <div class="flex items-center">
            <span class="text-gray-600 w-24">用户名:</span>
            <span class="font-mono flex-1">{{ getDictVal('bt_username') }}</span>
            <div link class="ml-2" @click="copyText(getDictVal('bt_username'))">
              复制
            </div>
          </div>
          <div class="flex items-center">
            <span class="text-gray-600 w-24">密码:</span>
            <span class="font-mono flex-1" v-if="!showPassword.bt_password">********</span>
            <span class="font-mono flex-1" v-else>{{ getDictVal('bt_password') }}</span>
            <div link class="ml-2" @click="togglePassword('bt_password')">
              <span v-if="!showPassword.bt_password">显示</span>
              <span v-else>隐藏</span>
            </div>
            <div link class="ml-2" @click="copyText(getDictVal('bt_password'))">
              复制
            </div>
          </div>
        </div>
      </div>

          <!-- 宝塔面板信息 -->
      <div class="bg-white rounded-xl shadow-sm p-6 mb-6">
        <div class="w-32 text-gray-700 font-medium mb-4">AI登录地址</div>
        <div class="space-y-4">
          <div class="flex items-center">
            <span class="text-gray-600 w-24">地址:</span>
            <a :href="getDictVal('ai_url')" target="_blank" class="text-blue-600 hover:underline flex-1">{{ getDictVal('ai_url') }}</a>
            <div link class="ml-2" @click="copyText(getDictVal('ai_url'))">
              复制
            </div>
          </div>
    
          <div class="flex items-center">
            <span class="text-gray-600 w-24">用户名:</span>
            <span class="font-mono flex-1">{{ getDictVal('ai_account') }}</span>
            <div link class="ml-2" @click="copyText(getDictVal('ai_account'))">
              复制
            </div>
          </div>
          <div class="flex items-center">
            <span class="text-gray-600 w-24">密码:</span>
            <span class="font-mono flex-1" v-if="!showPassword.ai_password">********</span>
            <span class="font-mono flex-1" v-else>{{ getDictVal('ai_password') }}</span>
            <div link class="ml-2" @click="togglePassword('ai_password')">
              <span v-if="!showPassword.ai_password">显示</span>
              <span v-else>隐藏</span>
            </div>
            <div link class="ml-2" @click="copyText(getDictVal('ai_password'))">
              复制
            </div>
          </div>
        </div>
      </div>

      <!-- 服务器信息 -->
      <div class="bg-white rounded-xl shadow-sm p-6 mb-6">
        <div class="w-32 text-gray-700 font-medium mb-4">服务器信息</div>
        <div class="grid grid-cols-2 md:grid-cols-3 gap-6">
          <div>
            <div class="text-gray-600 text-sm">Root密码</div>
            <div class="flex items-center">
              <span class="font-mono" v-if="!showPassword.server_root_password">********</span>
              <span class="font-mono" v-else>{{ getDictVal('server_root_password') }}</span>
              <div link class="ml-2" @click="togglePassword('server_root_password')">
                <span v-if="!showPassword.server_root_password">显示</span>
                <span v-else>隐藏</span>
              </div>
              <div link class="ml-2" @click="copyText(getDictVal('server_root_password'))">
                复制
              </div>
            </div>
          </div>
       
        </div>
      </div>

      <!-- API密钥信息 -->
      <div class="bg-white rounded-xl shadow-sm p-6 mb-6">
        <div class="w-32 text-gray-700 font-medium mb-4">API密钥</div>
        <div class="space-y-4">
          <div class="flex items-center">
            <span class="text-gray-600 w-36">DeepSeek API Key:</span>
            <span class="font-mono text-sm flex-1 truncate" v-if="!showPassword.deepseek_api_key">••••••••••••••••••••••••••••••</span>
            <span class="font-mono text-sm flex-1 truncate" v-else>{{ getDictVal('deepseek_api_key') }}</span>
            <div link class="ml-2" @click="togglePassword('deepseek_api_key')">
              <span v-if="!showPassword.deepseek_api_key">显示</span>
              <span v-else>隐藏</span>
            </div>
            <div link class="ml-2" @click="copyText(getDictVal('deepseek_api_key'))">
              复制
            </div>
          </div>
          <div class="flex items-center">
            <span class="text-gray-600 w-36">通义千问 API Key:</span>
            <span class="font-mono text-sm flex-1 truncate" v-if="!showPassword.tongyi_api_key">••••••••••••••••••••••••••••••</span>
            <span class="font-mono text-sm flex-1 truncate" v-else>{{ getDictVal('tongyi_api_key') }}</span>
            <div link class="ml-2" @click="togglePassword('tongyi_api_key')">
              <span v-if="!showPassword.tongyi_api_key">显示</span>
              <span v-else>隐藏</span>
            </div>
            <div link class="ml-2" @click="copyText(getDictVal('tongyi_api_key'))">
              复制
            </div>
          </div>
          <div class="flex items-center">
            <span class="text-gray-600 w-36">阿里云 AccessKey ID:</span>
            <span class="font-mono text-sm flex-1 truncate" v-if="!showPassword.aliyun_access_key_id">••••••••••••••••••••••••••••••</span>
            <span class="font-mono text-sm flex-1 truncate" v-else>{{ getDictVal('aliyun_access_key_id') }}</span>
            <div link class="ml-2" @click="togglePassword('aliyun_access_key_id')">
              <span v-if="!showPassword.aliyun_access_key_id">显示</span>
              <span v-else>隐藏</span>
            </div>
            <div link class="ml-2" @click="copyText(getDictVal('aliyun_access_key_id'))">
              复制
            </div>
          </div>
          <div class="flex items-center">
            <span class="text-gray-600 w-36">阿里云 AccessKey Secret:</span>
            <span class="font-mono text-sm flex-1 truncate" v-if="!showPassword.aliyun_access_key_secret">••••••••••••••••••••••••••••••</span>
            <span class="font-mono text-sm flex-1 truncate" v-else>{{ getDictVal('aliyun_access_key_secret') }}</span>
            <div link class="ml-2" @click="togglePassword('aliyun_access_key_secret')">
              <span v-if="!showPassword.aliyun_access_key_secret">显示</span>
              <span v-else>隐藏</span>
            </div>
            <div link class="ml-2" @click="copyText(getDictVal('aliyun_access_key_secret'))">
              复制
            </div>
          </div>
        </div>
      </div>

      <!-- 微信配置信息 -->
      <div class="bg-white rounded-xl shadow-sm p-6 mb-6">
        <div class="w-32 text-gray-700 font-medium mb-4">微信配置</div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="space-y-4">
            <h3 class="font-medium text-gray-700">小程序信息</h3>
            <div class="flex items-center">
              <span class="text-gray-600 text-sm w-20">AppID:</span>
              <span class="font-mono text-sm flex-1">{{ getDictVal('wx_app_id') }}</span>
              <div link class="ml-2" @click="copyText(getDictVal('wx_app_id'))">
                复制
              </div>
            </div>
            <div class="flex items-center">
              <span class="text-gray-600 text-sm w-20">AppSecret:</span>
              <span class="font-mono text-sm flex-1 truncate" v-if="!showPassword.wx_app_secret">••••••••••••••••••••••••••••••</span>
              <span class="font-mono text-sm flex-1 truncate" v-else>{{ getDictVal('wx_app_secret') }}</span>
              <div link class="ml-2" @click="togglePassword('wx_app_secret')">
                <span v-if="!showPassword.wx_app_secret">显示</span>
                <span v-else>隐藏</span>
              </div>
              <div link class="ml-2" @click="copyText(getDictVal('wx_app_secret'))">
                复制
              </div>
            </div>
          </div>
          <div class="space-y-4">
            <h3 class="font-medium text-gray-700">微信支付</h3>
            <div class="flex items-center">
              <span class="text-gray-600 text-sm w-20">商户号:</span>
              <span class="font-mono text-sm flex-1">{{ getDictVal('wx_mch_id') }}</span>
              <div link class="ml-2" @click="copyText(getDictVal('wx_mch_id'))">
                复制
              </div>
            </div>
            <div class="flex items-center">
              <span class="text-gray-600 text-sm w-20">API密钥:</span>
              <span class="font-mono text-sm flex-1 truncate" v-if="!showPassword.wx_api_key">••••••••••••••••••••••••••••••</span>
              <span class="font-mono text-sm flex-1 truncate" v-else>{{ getDictVal('wx_api_key') }}</span>
              <div link class="ml-2" @click="togglePassword('wx_api_key')">
                <span v-if="!showPassword.wx_api_key">显示</span>
                <span v-else>隐藏</span>
              </div>
              <div link class="ml-2" @click="copyText(getDictVal('wx_api_key'))">
                复制
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 小程序二维码模块 -->
      <div class="bg-white rounded-xl shadow-sm p-6 mb-6 flex items-center">
        <div class="w-32 text-gray-700 font-medium">微信小程序</div>
        <div class="flex-1 flex flex-col items-center">
          <img 
            :src="getDictVal('xcx_code')[0].file_path" 
            alt="小程序二维码" 
            class="w-40 h-40 object-contain mb-3"
          />
          <p class="text-gray-600 text-sm">微信扫码体验</p>
        </div>
      </div>


          <!-- APP下载码模块 -->
      <!-- <div class="bg-white rounded-xl shadow-sm p-6 mb-6 flex items-center">
        <div class="w-32 text-gray-700 font-medium">移动应用</div>
        <div class="flex-1 flex space-x-12">
          <div class="text-center">
            <img 
              src="https://ai-public.mastergo.com/ai/img_res/4305c2a0d09439d6fb00a35b5f605d3e.jpg" 
              alt="iOS下载码" 
              class="w-36 h-36 object-contain mx-auto mb-2"
            />
            <div class="font-medium">iOS 版本</div>
            <div class="text-gray-500 text-sm">v2.1.4 · iOS 12.0+</div>
          </div>
          <div class="text-center">
            <img 
              src="https://ai-public.mastergo.com/ai/img_res/66db008a2e2aeae275efc3855f4221a1.jpg" 
              alt="Android下载码" 
              class="w-36 h-36 object-contain mx-auto mb-2"
            />
            <div class="font-medium">Android 版本</div>
            <div class="text-gray-500 text-sm">v2.1.4 · Android 6.0+</div>
          </div>
        </div>
      </div> -->


    </div>
  </div>

</template>

<script >
    import { Message, MessageBox } from 'element-ui'

export default {
  data() {
    return {
   
       showPassword: {
        ai_password: false,
        bt_password: false,
        server_root_password: false,
        deepseek_api_key: false,
        tongyi_api_key: false,
        aliyun_access_key_id: false,
        aliyun_access_key_secret: false,
        wx_app_secret: false,
        wx_api_key: false
      }
    }
  },
  methods: {
     // 切换密码显示状态
    togglePassword(key) {
      this.showPassword[key] = !this.showPassword[key]
    },
    // 复制文本功能
    copyText(text) {
      navigator.clipboard.writeText(text).then(() => {
        Message.success('已复制到剪贴板')
      }).catch(() => {
        Message.error('复制失败')
      })
    },
    
    // 刷新信息
    refreshInfo() {
      Message.info('正在刷新系统信息...')
      // 模拟刷新操作
      setTimeout(() => {
        Message.success('信息刷新成功')
      }, 1000)
    },
    
    // 导出配置
    exportConfig() {
      MessageBox.confirm(
        '确定要导出当前系统配置吗？',
        '导出配置',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        Message.success('配置文件已导出')
      }).catch(() => {
        // 用户取消操作
      })
    },
    
    // 联系支持
    contactSupport() {
      MessageBox.alert(
        '技术支持热线：400-123-4567<br/>服务时间：工作日 9:00-18:00',
        '联系支持',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '知道了',
        }
      )
    }
  }
}
</script>

<style scoped>
/* 为所有按钮添加圆角样式 */
:deep(.el-button) {
  border-radius: 8px !important;
}
</style>




// WEBPACK FOOTER //
// src/views/home/homex.vue